import { useMemo, useState } from "react";
import { History } from "lucide-react";
import { dataBR } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { EmptyState, Field, Surface } from "@/components/ds";
import { NativeSelect } from "@/components/ds/NativeSelect";

const TYPES = [
  { value: "", label: "Tudo" },
  { value: "ENVIO", label: "Reposições" },
  { value: "VENDA", label: "Vendas" },
  { value: "DEVOLUCAO", label: "Devoluções" },
  { value: "AJUSTE", label: "Ajustes" },
];

export function PartnerHistory({ movements, closures }) {
  const [type, setType] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const rows = useMemo(
    () =>
      movements.filter((m) => {
        if (type && m.type !== type) return false;
        const day = (m.created_at || "").slice(0, 10);
        if (from && day < from) return false;
        if (to && day > to) return false;
        return true;
      }),
    [movements, type, from, to]
  );

  return (
    <div className="space-y-6" data-testid="partner-history">
      <Surface className="grid gap-3 p-5 sm:grid-cols-3">
        <Field label="Tipo">
          <NativeSelect value={type} onChange={setType} options={TYPES} data-testid="history-type-select" />
        </Field>
        <Field label="De">
          <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="font-num" data-testid="history-from-input" />
        </Field>
        <Field label="Até">
          <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="font-num" data-testid="history-to-input" />
        </Field>
      </Surface>

      {rows.length === 0 ? (
        <EmptyState icon={History} title="Sem movimentações no período" description="Ajuste os filtros para ver mais." />
      ) : (
        <Surface className="p-5">
          <ul className="divide-y divide-white/10" data-testid="partner-history-list">
            {rows.map((m) => (
              <li key={m.id} className="flex min-w-0 items-center gap-3 py-3">
                <span className="w-14 shrink-0 font-num text-xs text-muted-foreground">
                  {dataBR(m.created_at)}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm">{m.product_name}</p>
                  <p className="truncate text-xs text-muted-foreground">{m.type_label}</p>
                </div>
                <span
                  className={`shrink-0 font-num text-sm ${m.quantity >= 0 ? "text-emerald-300" : "text-red-300"}`}
                >
                  {m.quantity >= 0 ? "+" : "−"}
                  {Math.abs(m.quantity).toLocaleString("pt-BR")} un
                </span>
              </li>
            ))}
          </ul>
        </Surface>
      )}

      {closures.length > 0 && (
        <Surface className="p-5" data-testid="history-closures">
          <p className="mb-3 text-xs uppercase tracking-wide text-muted-foreground">Fechamentos</p>
          <ul className="divide-y divide-white/10">
            {closures.map((c) => (
              <li key={c.id} className="flex items-center justify-between gap-3 py-2.5 text-sm">
                <span className="min-w-0 truncate">
                  {c.number} · {c.period_label}
                </span>
                <span className="shrink-0 font-num text-xs">
                  {c.status === "PAGO" ? "Pago" : "Em aberto"}
                </span>
              </li>
            ))}
          </ul>
        </Surface>
      )}
    </div>
  );
}
